// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-table {
  margin: 20px auto;
  width: 72%;
  min-height: 110vh;
}
.table-heading {
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  text-align: left;
  padding-bottom: 20px;
}
.status-table-header {
  /* padding-left: 25px !important; */
  border-top-left-radius: 20px;
}

.status-table-header-cell {
  padding: 10px;
  font-weight: bold;
  background-color: #efefef;
}

.status-table-row {
  cursor: pointer;
}

.status-table-row:hover {
  background-color: #f7f7f7;
}

.status-chip {
  display: inline-block;
  width: 126px;
  padding: 5px 10px;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
}

.status-chip.accepted {
  background-color: #4caf50;
}

.status-chip.rejected {
  background-color: #f44336;
}

.pagination-container {
  margin-top: 9px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.status-table-paper {
  display: flex;
  flex-grow: 1;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden !important;
}
.header-section {
  display: flex;
  justify-content: space-between;
  /* flex-direction: row; */
}
.filter-container {
  display: flex;
  align-items: center;
  gap: 20px;
}
.date-title {
  font-size: 14px;
  font-weight: 500;
  color: #191919;
  margin-right: -5px;
}
.no-data-state {
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: absolute; */
  width: 71.5vw;
  top: 265px;
}
.no-data-table {
  min-height: 500px;
}
.no-data-col {
  border-bottom: none !important;
}
.status-table-row-customer,
.status-table-row-business {
  max-width: 150px;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
.sort-arrow {
  margin-left: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.sort-arrow.ascending {
  transform: rotate(0deg);
}

.sort-arrow.descending {
  transform: rotate(180deg);
}

.status-table-created-on {
  display: flex !important;
  align-items: center;
}

.exoprt-btn {
  background-color: #f77c7c;
  min-width: 129px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border: none;
  border-radius: 40px;
  height: 32px;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customerStatusTable/customerStatusTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".status-table {\n  margin: 20px auto;\n  width: 72%;\n  min-height: 110vh;\n}\n.table-heading {\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: left;\n  padding-bottom: 20px;\n}\n.status-table-header {\n  /* padding-left: 25px !important; */\n  border-top-left-radius: 20px;\n}\n\n.status-table-header-cell {\n  padding: 10px;\n  font-weight: bold;\n  background-color: #efefef;\n}\n\n.status-table-row {\n  cursor: pointer;\n}\n\n.status-table-row:hover {\n  background-color: #f7f7f7;\n}\n\n.status-chip {\n  display: inline-block;\n  width: 126px;\n  padding: 5px 10px;\n  border-radius: 20px;\n  color: #fff;\n  font-weight: bold;\n  text-align: center;\n}\n\n.status-chip.accepted {\n  background-color: #4caf50;\n}\n\n.status-chip.rejected {\n  background-color: #f44336;\n}\n\n.pagination-container {\n  margin-top: 9px;\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.status-table-paper {\n  display: flex;\n  flex-grow: 1;\n  border-top-left-radius: 20px !important;\n  border-top-right-radius: 20px !important;\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n  padding: 0;\n  margin: 0;\n  overflow-y: auto;\n  overflow-x: hidden !important;\n}\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  /* flex-direction: row; */\n}\n.filter-container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.date-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #191919;\n  margin-right: -5px;\n}\n.no-data-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* position: absolute; */\n  width: 71.5vw;\n  top: 265px;\n}\n.no-data-table {\n  min-height: 500px;\n}\n.no-data-col {\n  border-bottom: none !important;\n}\n.status-table-row-customer,\n.status-table-row-business {\n  max-width: 150px;\n  overflow: hidden;\n  text-wrap: nowrap;\n  text-overflow: ellipsis;\n}\n.sort-arrow {\n  margin-left: 8px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.sort-arrow.ascending {\n  transform: rotate(0deg);\n}\n\n.sort-arrow.descending {\n  transform: rotate(180deg);\n}\n\n.status-table-created-on {\n  display: flex !important;\n  align-items: center;\n}\n\n.exoprt-btn {\n  background-color: #f77c7c;\n  min-width: 129px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  border: none;\n  border-radius: 40px;\n  height: 32px;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
